"use strict";

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

/**
 * This function removes a parameter from the query string of the given URL
 * @param {string} url - The url which contains the query string that will have the param removed
 * @param {string} parameter - The name of the parameter that has to be removed
 */
function removeURLParameter(url, parameter) {
    var urlParts = url ? url.split("?") : [];

    if (urlParts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + "=";
        var pars = urlParts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlParts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
        return url;
    } else {
        return url;
    }
}

/**
 * This function gets an a key and a value and adds it to the given url query string
 * @param {string} url - The base url used for adding the parameter in the query string
 * @param {string} key - The key of the param that will be added to the url
 * @param {string} value - The value of the param that will be added to the url
 */

function insertParam(url, key, value) {
    url = removeURLParameter(url, key);

    var queryStart = url.indexOf("?") !== -1 ? "&" : "?";

    return url + queryStart + key + "=" + value;
}

/**
 * This functions gets an url and a key to return the value of the param, if exists, of the query string
 * @param {string} url - The base url used for searching the query string
 * @param {string} key - Which key should be searched in the query string
 */
function getQueryStringValue(url, key) {
    return decodeURIComponent(url.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

module.exports = {
    appendToUrl : appendToUrl,
    removeURLParameter: removeURLParameter,
    insertParam: insertParam,
    getQueryStringValue: getQueryStringValue
};
